import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { loggedUserSelector, errorSelector, fetchingPassword} from '../../selectors/loggedUser';
import { setUserLogin, changeExpiredPasswordRequest } from '../../actions/loggedUser';
import { signOut } from '../../../auth/actions/signout';
import EntryPoint from './EntryPoint';
import { companySelector } from '../../../app/selectors/company';
import { setAgentStatusEvent, setNotificationSocketEvent, setProfileUpdatedEvent, setCommentsSocketEvent,
    setTasksEvent, setTaskEvent, setSocialOutgoingEvent, setSocialIncomingEvent, setUpdateCommentEvent, setNewCommentEvent, setTaskCreatedEvent, setTasksClosedEvent, addTasksListEvent, setTaskUpdatedEvent} from '../../../shared/actions/socketEvents';
import { permissionsSelector } from '../../../auth/selectors/permissions'
import { notificationsSelector } from '../../selectors/notifications';

const mapStateToProps = createStructuredSelector({
    loggedUser: loggedUserSelector,
    error: errorSelector,
    company: companySelector,
    fetchingPassword: fetchingPassword,
    permissions: permissionsSelector,
    notifications: notificationsSelector
});

const mapDispatchToProps = {
    setUserLogin,
    signOut,
    changeExpiredPasswordRequest,
    setAgentStatusEvent,
    setNotificationSocketEvent,
    setAgentStatusEvent,
    setProfileUpdatedEvent,
    setCommentsSocketEvent,
    setTasksEvent,
    setTaskEvent,
    setSocialOutgoingEvent,
    setSocialIncomingEvent,
    setUpdateCommentEvent,
    setNewCommentEvent,
    setTaskCreatedEvent,
    setTaskUpdatedEvent,
    setTasksClosedEvent,
    addTasksListEvent,
};
export default connect(mapStateToProps, mapDispatchToProps)(EntryPoint);